// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber3 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M8.506 14.102c.126 1.792 1.344 3.08 3.472 3.08 2.142 0 3.514-1.26 3.514-3.108 0-1.232-.658-2.142-1.862-2.534v-.028c.812-.406 1.4-1.092 1.4-2.086 0-1.554-1.19-2.632-3.01-2.632-1.848 0-3.01 1.134-3.066 2.744l1.61.07c.084-.826.56-1.358 1.414-1.358.742 0 1.344.42 1.344 1.246 0 1.064-.882 1.428-2.044 1.428v1.386h.406c1.176 0 2.058.504 2.058 1.708 0 .966-.672 1.722-1.736 1.722-1.12 0-1.722-.672-1.806-1.708z" />
  );
export default SvgIconNumber3;
